// extracted by mini-css-extract-plugin
module.exports = {"App":"Button_App__Mw4w5","Button":"Button_Button__2BYYQ"};